// TODO: Move folder to models.
export default class PaginationResponse<T> {

  public items: T[] = []
  public totalItems: number = 0
}
